import React from "react";
import { observer } from "mobx-react";
import { PublisherRepresentativeUpdateStore } from "../../store";
import { PublisherRepresentativeUpdateForm } from "./PublisherRepresentativeUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type PublisherRepresentativeUpdateProps = {
  publisherRepresentativeUpdateStore: PublisherRepresentativeUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PublisherRepresentativeUpdate: React.FC<PublisherRepresentativeUpdateProps> =
  observer(
    ({
      publisherRepresentativeUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={publisherRepresentativeUpdateStore.isSaving} />
          <PublisherRepresentativeUpdateForm
            publisherRepresentativeUpdateStore={
              publisherRepresentativeUpdateStore
            }
            nameError={publisherRepresentativeUpdateStore.errors.name?.message}
            onNameChange={(value: string) => {
              publisherRepresentativeUpdateStore.setNameValue(value);
            }}
            name={publisherRepresentativeUpdateStore.entityValues.name}
            roleError={publisherRepresentativeUpdateStore.errors.role?.message}
            onRoleChange={(value: string) => {
              publisherRepresentativeUpdateStore.setRoleValue(value);
            }}
            role={publisherRepresentativeUpdateStore.entityValues.role}
            emailError={
              publisherRepresentativeUpdateStore.errors.email?.message
            }
            onEmailChange={(value: string) => {
              publisherRepresentativeUpdateStore.setEmailValue(value);
            }}
            email={publisherRepresentativeUpdateStore.entityValues.email}
            phoneError={
              publisherRepresentativeUpdateStore.errors.phone?.message
            }
            onPhoneChange={(value: string) => {
              publisherRepresentativeUpdateStore.setPhoneValue(value);
            }}
            phone={publisherRepresentativeUpdateStore.entityValues.phone}
            isSignerError={
              publisherRepresentativeUpdateStore.errors.isSigner?.message
            }
            onIsSignerChange={(value: boolean) => {
              publisherRepresentativeUpdateStore.setIsSignerValue(value);
            }}
            isSigner={publisherRepresentativeUpdateStore.entityValues.isSigner}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={publisherRepresentativeUpdateStore.saveDisabled}
            onSave={() =>
              publisherRepresentativeUpdateStore.savePublisherRepresentative()
            }
            onCancel={() =>
              publisherRepresentativeUpdateStore.cancelPublisherRepresentative()
            }
          />
          <ErrorDialog
            open={publisherRepresentativeUpdateStore.errorDialogOpened}
            title={publisherRepresentativeUpdateStore.errorTitle}
            description={publisherRepresentativeUpdateStore.errorDescription}
            onClose={() =>
              publisherRepresentativeUpdateStore.closeErrorDialog()
            }
          />
          <ConfirmCancelDialog
            open={publisherRepresentativeUpdateStore.confirmDialogOpened}
            title={publisherRepresentativeUpdateStore.confirmDialogTitle}
            description={
              publisherRepresentativeUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              publisherRepresentativeUpdateStore.executeConfirmedAction()
            }
            onCancel={() =>
              publisherRepresentativeUpdateStore.closeConfirmDialog()
            }
          />
        </>
      );
    }
  );
